import { render, staticRenderFns } from "./buy-quote.vue?vue&type=template&id=b895a226&scoped=true&"
import script from "./buy-quote.vue?vue&type=script&lang=js&"
export * from "./buy-quote.vue?vue&type=script&lang=js&"
import style0 from "./buy-quote.vue?vue&type=style&index=0&id=b895a226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b895a226",
  null
  
)

export default component.exports